import { type SVGAttributes } from "react";

export const Hamburger = ({ ...rest }: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="100%"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M23 19.25C23 19.4487 22.9212 19.64 22.7806 19.7806C22.64 19.9212 22.4488 20 22.25 20H2.75001C2.33563 20 2.00001 19.6644 2.00001 19.25C2.00001 18.8356 2.33563 18.5 2.75001 18.5H22.25C22.4488 18.5 22.64 18.5787 22.7806 18.7194C22.9212 18.86 23 19.0513 23 19.25ZM2.75 7H22.25C22.6644 7 23 6.66438 23 6.25C23 5.83562 22.6644 5.5 22.25 5.5H2.75C2.33562 5.5 2 5.83562 2 6.25C2 6.66438 2.33562 7 2.75 7ZM22.25 12H2.75C2.33562 12 2 12.3356 2 12.75C2 13.1644 2.33562 13.5 2.75 13.5H22.25C22.6644 13.5 23 13.1644 23 12.75C23 12.3356 22.6644 12 22.25 12Z"
        fill="#353B3F"
        stroke="#353B3F"
      />
    </svg>
  );
};
